import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
} from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { Box } from "@mui/system";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import api from "../../../services/QualityAssurance";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useGetClassAndSubjectTeacherQuery, useGetLessonSessionsQuery } from "../../../api/lessonNoteApi";
import TableLoader from "../../TableLoader";


export const TableReviewSheet = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [schoolProfileData, setSchoolprofileData] = useState(null);
  const [selectedSession, setSelectedSession] = useState({
    sessionId: 0,
    sessionName: ''
  });

  const [selectedClasses, setSelectedClasses] = useState({
    classId: 0,
    className: ''
  });

  const { data: sessions, isLoading: sessionsLoading } = useGetLessonSessionsQuery();
  const { data: classAndArm, isLoading } = useGetClassAndSubjectTeacherQuery(user ? user.schoolId : 0);

  useEffect(() => {
    const schoolProfile = async () => {
      setLoading(true);
      try {
        const res = await api.getSchoolProfile(admToken, user.schoolId);
        if (res.status && res.statusCode === 2) {
          setSchoolprofileData(res.data);
        } else {
          toast.error(res.data.message || res.message);
        }
      } catch (error) {
        console.error("Error loading:", error);
      } finally {
        setLoading(false);
      }
    };
    schoolProfile();
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await api.getTimeTablePreview(admToken, selectedSession.sessionId, selectedClasses.classId);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
      } else {
        toast.error(res.data.message || res.message);
      }
    } catch (error) {
      console.error("Error loading:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const selectedSession = sessions?.data?.find(s => s.id === value);
    setSelectedSession(prev => ({
      ...prev,
      [name]: value,
      sessionName: selectedSession ? selectedSession.name : ''
    }));
  };

  const handleChangeClass = (e) => {
    const { name, value } = e.target;
    const selectedClass = classAndArm?.data?.find(s => s.id === value);
    setSelectedClasses(prev => ({
      ...prev,
      [name]: value,
      className: selectedClass ? selectedClass.name : ''
    }));
  };

  const timetableDays = data?.days || [];
  const specialPeriods = data?.specialPeriods || [];
  const timeSlots = data?.timeSlots || [];
  const fridayTimeSlots = data?.fridayTimeSlots || [];

  return (
    <>
      <div className="flex bg-[#691e78] px-3 py-3 gap-3 mb-5 rounded-lg">
        <FormControl fullWidth>
          <InputLabel
            sx={{
              mb: 1.5,
              mt: 1,
              fontSize: "22px",
              fontWeight: "bolder",
              color: "#fff",
              fontFamily: "Gilroy-Medium",
            }}
          >
            Session
          </InputLabel>
          <Select
            name="sessionId"
            sx={{
              fontFamily: "Gilroy-Regular",
              border: "0.5px solid #fff",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid #fff",
                },
              },
              color: "#fff",
            }}
            variant="outlined"
            size="small"
            value={selectedSession.sessionId}
            onChange={handleChange}
            disabled={sessionsLoading}
          >
            {sessionsLoading ? (
              <MenuItem disabled>Loading session...</MenuItem>
            ) : !sessions?.data || sessions.data.length === 0 ? (
              <MenuItem disabled>No session available</MenuItem>
            ) : (
              sessions.data.map((session) => (
                <MenuItem
                  sx={{ fontFamily: "Gilroy-Regular" }}
                  value={session.id}
                  key={session.id}
                >
                  {session.name}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            sx={{
              mb: 1.5,
              mt: 1,
              fontSize: "22px",
              fontWeight: "bolder",
              color: "#fff",
              fontFamily: "Gilroy-Medium",
            }}
          >
            Class
          </InputLabel>
          <Select
            name="classId"
            sx={{
              fontFamily: "Gilroy-Regular",
              border: "0.5px solid #fff",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid #fff",
                },
              },
              color: "#fff",
            }}
            variant="outlined"
            size="small"
            value={selectedClasses.classId}
            onChange={handleChangeClass}
            disabled={isLoading}
          >
            {isLoading ? (
              <MenuItem disabled>Loading class...</MenuItem>
            ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
              <MenuItem disabled>No session available</MenuItem>
            ) : (
              classAndArm.data.map((item) => (
                <MenuItem
                  sx={{ fontFamily: "Gilroy-Regular" }}
                  value={item.classId}
                  key={item.classId}
                >
                  {item.className} {item.classArm}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
        <button
          type="submit"
          onClick={handleSubmit}
          className="items-center text-[#691e78] bg-white flex justify-center px-8 py-1.5 rounded-sm">
          Load
        </button>
      </div>
      {loading ? <TableLoader /> :
        <>
          {data &&
            <>
              <Box
                mb={10}
                sx={{
                  position: "relative",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      textAlign: "center",
                      margin: "0 auto",
                      width: { lg: "97%", md: "97%", sm: "98%", xs: "99%" },
                    }}
                  >
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <Avatar src={schoolProfileData?.logo} />
                      <Typography
                        variant="h5"
                        sx={{
                          fontFamily: "Gilroy-Heavy",
                          fontSize: { xs: "14px", lg: "20px" },
                        }}
                      >
                        {schoolProfileData?.schoolname}
                      </Typography>
                    </Box>
                    <Box mb={2} sx={{ margin: "0 auto", width: "90%" }}>
                      <Grid
                        container
                        sx={{
                          borderRadius: "20px",
                          fontFamily: "Gilroy-Regular",
                        }}
                      >
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                          <Box
                            sx={{
                              my: { lg: 2, xs: 1 },
                              pr: { lg: 3.5, xs: 0 },
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-end",
                              borderRight: {
                                lg: "1px solid #671e78",
                                xs: "none",
                                md: "1px solid #671e781a",
                                sm: "1px solid #671e781a",
                              },
                              textAlign: { lg: "right", xs: "center" },
                            }}
                          >
                            <span style={{ fontSize: "14px", marginBottom: "10px" }}>
                              {schoolProfileData?.schooladdress}
                              <AllInboxIcon
                                sx={{ ml: 1, mb: -0.6, fontSize: "18px" }}
                              />
                            </span>{" "}
                            <span style={{ fontSize: "14px" }}>
                              {schoolProfileData?.schoolemail}
                              <EmailIcon sx={{ ml: 1, mb: -0.6, fontSize: "18px" }} />
                            </span>{" "}
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sm={6}
                          sx={{ textAlign: "left", my: { lg: 2, xs: -0.6 } }}
                        >
                          <Box
                            sx={{
                              textAlign: { lg: "left", xs: "center" },
                              ml: { lg: 2, xs: 0 },
                            }}
                          >
                            <span style={{ fontSize: "14px", marginBottom: "12px" }}>
                              <LocalPhoneIcon
                                sx={{ mr: 1, mb: -0.6, fontSize: "18px" }}
                              />
                              {schoolProfileData?.schoolphone}
                            </span>{" "}
                            <br />
                            <span style={{ fontSize: "14px" }}>
                              <LanguageIcon
                                sx={{ mr: 1, mb: -0.6, fontSize: "18px" }}
                              />
                              {schoolProfileData?.portal_url}
                            </span>{" "}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        bgcolor: "#671E78",
                        p: 1,
                        borderRadius: "20px",
                        pb: 2,
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant="body"
                        sx={{
                          color: "#fff",
                          fontFamily: "Gilroy-Medium",
                          fontSize: { xs: "10px", md: "16px", sm: "14px", lg: "16px" },
                        }}
                      >
                        School TimeTable - {data?.session} Session
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        bgcolor: "#671E78",
                        width: "40%",
                        margin: "0 auto 15px",
                        p: 1,
                        borderRadius: "20px",
                        position: "relative",
                        top: "-8px",
                      }}
                    >
                      <Typography
                        variant="body"
                        sx={{
                          color: "#fff",
                          fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "10px" },
                          fontFamily: "Gilroy-Regular",
                        }}
                      >
                        {data?.className} {data?.classArm}
                      </Typography>
                    </Box>
                  </Box>
                  <strong>Name: {data?.createdBy}</strong>
                  <Box
                    mt={3}
                    className="sheet_table card_class"
                    sx={{ overflowX: "scroll" }}
                  >
                    <table className="timetable w-full border-collapse border border-gray-300 text-sm">
                      <thead className="bg-purple-100 text-gray-800">
                        <tr>
                          {timeSlots.map((time, i) => (
                            <th key={i}>
                              <p className="text-xs">{time.start}</p>
                              <p className="text-xs">{time.end}</p>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {timetableDays.map((dayItem, dayIndex) => (
                          <tr key={dayItem.day}>
                            <td className="border px-2 py-1 font-semibold">{dayItem.day}</td>

                            {/* Only insert these once, using rowSpan */}
                            {dayIndex === 0 && (
                              <>
                                <td rowSpan={5} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[0]}</td>
                                <td rowSpan={5} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[1]}</td>
                              </>
                            )}

                            {/* Periods 3, 4, 5 */}
                            {dayItem.periods.slice(0, 3).map((subj, idx) => (
                              <td key={`p1-${idx}`} className="border px-2 py-1">{subj.period}</td>
                            ))}

                            {dayIndex === 0 && (
                              <td rowSpan={4} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[2]}</td>
                            )}

                            {/* Periods 7, 8 */}
                            {dayItem.periods.slice(3, 5).map((subj, idx) => (
                              <td key={`p2-${idx}`} className="border px-2 py-1">{subj.period}</td>
                            ))}

                            {dayIndex === 0 && (
                              <td rowSpan={4} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[3]}</td>
                            )}

                            {/* Periods 10, 11 */}
                            {dayItem.periods.slice(5, 7).map((subj, idx) => (
                              <td key={`p3-${idx}`} className="border px-2 py-1">{subj.period}</td>
                            ))}

                            {dayIndex === 0 && (
                              <td rowSpan={5} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[4]}</td>
                            )}

                            {/* Periods 13, 14, 15 */}
                            {dayItem.periods.slice(7).map((subj, idx) => (
                              <td key={`p4-${idx}`} className="border px-2 py-1">{subj.period}</td>
                            ))}

                            {dayIndex === 0 && (
                              <>
                                <td rowSpan={4} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[5]}</td>
                                <td rowSpan={4} className="border px-2 py-6 align-middle text-center whitespace-nowrap rotate-90">{specialPeriods[6]}</td>
                              </>
                            )}
                          </tr>
                        ))}
                        <tr>
                          {fridayTimeSlots.map((time, i) => (
                            <td key={i}>
                              <p className="text-xs">{time.start}</p>
                              <p className="text-xs">{time.end}</p>
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                </Box>
              </Box>
            </>
          }
        </>
      }
    </>
  );
};

